// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1Wj0m","tooltip":"_3FBsU","tooltipIcon":"_3-7Qi"};